import { CountryCode, FirestoreCountry, FirestoreUserProfile } from '@/data/types';
import { countries as staticCountries } from '@/data/countries';

const VALID_CODES: CountryCode[] = ['SA', 'AE', 'EG', 'KW', 'OM', 'BH', 'QA'];

function isCountryCode(value: string | undefined): value is CountryCode {
  return !!value && VALID_CODES.includes(value as CountryCode);
}

/**
 * Prefer country stored on the user profile at signup; otherwise infer from
 * the app’s selected country (Firestore doc); else Saudi Arabia.
 */
export function resolveUserCountryCode(
  profile: FirestoreUserProfile | null | undefined,
  selectedCountryId: string | null,
  countries: FirestoreCountry[],
): CountryCode {
  if (isCountryCode(profile?.countryCode)) {
    return profile!.countryCode!;
  }

  if (selectedCountryId) {
    const fc = countries.find((c) => c.id === selectedCountryId);
    if (fc) {
      if (isCountryCode(fc.code)) return fc.code;
      const m = staticCountries.find((s) => s.name === fc.nameAr);
      if (m) return m.code;
    }
  }

  return 'SA';
}
